// Copyright (c) 2026 Comsearch, Inc., All rights reserved

import { ProjectTypeIdEnum } from 'config/enums'
import isEBandPath from 'helpers/isEBandPath'

const canCreateRadioFavoriteOnPath = (projectTypeId, bandId) => (
  !(projectTypeId === ProjectTypeIdEnum.ENGINEERING && isEBandPath(bandId))
)

export default canCreateRadioFavoriteOnPath
